export default __webpack_public_path__ + "static/Messaging Platform Copy – 800px-3841da873f629356d2ec839e849c8964.svg";